import { render, staticRenderFns } from "./follow_up_customer_list.vue?vue&type=template&id=0a5c906c&scoped=true&"
import script from "./follow_up_customer_list.vue?vue&type=script&lang=js&"
export * from "./follow_up_customer_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5c906c",
  null
  
)

export default component.exports